import React, { useContext, useMemo } from 'react';

export interface CalculationFlags {
  variantsEnabled: boolean;
  isOffline: boolean;
}

const CalculationFlagsContext = React.createContext<CalculationFlags>({
  variantsEnabled: false,
  isOffline: false
});

export const CalculationFlagsProvider: React.FC<CalculationFlags> = ({
  variantsEnabled,
  isOffline,
  children
}) => {
  const value = useMemo(() => ({ variantsEnabled, isOffline }), [variantsEnabled, isOffline]);
  return (
    <CalculationFlagsContext.Provider value={value}>{children}</CalculationFlagsContext.Provider>
  );
};

export const useVariantsEnabled = (): boolean =>
  useContext(CalculationFlagsContext).variantsEnabled;

export const useCaseIsOffline = (): boolean => useContext(CalculationFlagsContext).isOffline;
